
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/support",
      function () {
        return require("private-next-pages/account/support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/support"])
      });
    }
  